/**
 * Created by hp on 2017/8/21.
 */
import React, {Component} from 'react';

class RelaySettingTopBar extends Component {
    render() {
        return(
            <div className="relay-setting-top-bar">
                转载者列表
            </div>
        )
    }
}

export default RelaySettingTopBar;



// WEBPACK FOOTER //
// ./src/components/relaySetting/RelaySettingTopBar.js